import { Box, Stack, Grid, Typography } from "@mui/material";
import Icon from "@mdi/react";

type CardComponentProps = {
  icon: any;
  title: string;
  stats: string;
};

const CardComponent = ({ icon, title, stats }: CardComponentProps) => {
  return (
    <>
      <Grid item xs={12} sm={5.8} md={3.8} lg={3.8} xl={1.5} className="card">
        <Stack direction="row" spacing={1.5} className="card-content">
          <Stack
            className="icon-container"
            justifyContent="center"
            alignItems="center"
          >
            <Icon path={icon} title={title} size={1} className="card-icon" />
          </Stack>
          <Box>
            <Typography className="stats">{stats ? stats : 0} {stats ? "+" : ""}</Typography>
            <Typography className="title">{title}</Typography>
          </Box>
        </Stack>
      </Grid>
    </>
  );
};

export default CardComponent;
